import React, { useState } from 'react'

import Card from '../Card'
import CustomModal from '../CustomModal'
import Button from '../Button'

const Close = require('../../assets/icons/modal/Close.svg')

const InfoWindowBox = (props) => {
  const [ , setModalStatus ] = useState(false)

  const renderModalContent = () => {
    return
  }

  const onclickOpen = (value) => {
    props.onclickOpen(value)
    setModalStatus(value)
  }
  const greyBulb =()=>{
    props.history.push({
      pathname: '/OutageWarning/OutageMap/Contacts',
    })
  }

  const infoContent = [
    {
      colorCode: 1,
      isPole_Number: true,
      content: "National Grid does not own this light. View your city directory using the button below.",
      buttonText: "Street Light Directory",
      isButton: true,
    },
    {
      colorCode: 2,
      isPole_Number: true,
      content: "There are no known problems with this light. If you would like to continue reporting, click the button below.",
      buttonText: "Report This Light",
      isButton: true,
    },
    {
      colorCode: 3,
      isPole_Number: true,
      content: "This streetlight has been reported and currently under maintenance. No further action is needed at this time.",
      buttonText: "",
      isButton: false,
    },
    {
      colorCode: 4,
      isPole_Number: false,
      content: `This light is not accounted for in our inventory.
                Please ensure the location is accurate.
                Click the button below to continue reporting.`,
      buttonText: "Report This Light",
      isButton: true,
    },
  ]

  return (
    infoContent.map((data, index) => {
      const { asset, markerColorCode, closeInfoWindow } = props
      const { content, isButton, buttonText, colorCode } = data

      if (colorCode === markerColorCode) {
        const hasPoleNumber = (asset.poleNumber !== null && asset.poleNumber !== undefined)

        return (
          <Card className="overview" key={index}>
            <div className="bulbContent" data-test="infowindowContent">
              {asset.status !== "Adhoc" ? 
                <div>
                  { hasPoleNumber && 
                  <div  className="infowindowHeader">
                    <span className="InfoPole">
                      Pole Number : <strong>{asset.poleNumber}</strong>
                    </span>
                    <span className="closeButton">
                      <img src={Close} alt='close-button' onClick = {closeInfoWindow} className="mouse-pointer"/>
                    </span>
                  </div>
                  }
                  <p className='infocontent'>{content}</p>
                </div> :
                <div>
                  <div className = "infowindowHeader">
                    <span className="closeButton"> 
                      <img src={Close} alt='close-button' onClick = {closeInfoWindow} className="mouse-pointer"/> 
                    </span>
                  </div>
                  <p className='infocontent'>{content}</p>
                </div>
              }
            </div>
            {isButton === true && colorCode === 1 ?
              <div className="greybuttonDiv"> 
                <Button
                  className="greybutton"
                  aria-label={`greyButton contacts`}
                  data-a11y-focus="first"
                  onClick={greyBulb}
                >
                  {buttonText}
                </Button>
              </div>
              : (isButton === true && (colorCode === 2 || colorCode === 4)) ?
                <div className='infoaction'>
                  <CustomModal buttonText={buttonText} onclickOpen={onclickOpen} modalContent={renderModalContent()} />
                </div>: ""}  
          </Card>
        )
      }
      return false
    }).filter(Boolean)
  )
}

export default InfoWindowBox
